import {PartMenuType} from "../../visComponents/constants";
import {iCmp} from "../../../misc/utils";
import Layer from "../../visComponents/layer";
import {LayoutType, METADATA} from "./constants";
import PartCommon from "../../visComponents/partCommon";
import LayoutFeaturesList from "../../visComponents/layoutFeaturesList";
import DesignNavigationItem from "../../visComponents/designNavigationItem";

export class Part extends PartCommon {

  constructor(isParent, isChild, menuType) {
    super();
    if (isChild || (isParent && menuType === PartMenuType.Simple)) {
      // every feature is stored ONCE + a layout mask (was: an array per layout, not-in-visualizer features copied into all of them)
      this.featuresList = new LayoutFeaturesList(Object.keys(LayoutType));
      this.featuresPartsList = new LayoutFeaturesList(Object.keys(LayoutType));
      this.allFeaturesReceived = false;
      this.realFeaturesReceived = false; // this prop is need on Scroll (if features count more that 1000)
      this.nextFeaturesPageToLoad = 0;
      this.activeFeature = null;
      this.placeholderFeature = null;
      this.placeholderChanged = false;
      this.firstClick = {
        "0": false
      };
      this.activeLockedFeature = null;
      this.activeNotInVisualizerFeature = null; // is needed to display in the QT selected activeNotInVisualizerFeature, but render proper activeFeature layer(for example, countertop)
      // name = "";
      this.visible = true;
      this.categoryEnabled = false;
      this.layout = null;
      this.featureGroupVisible = true;  // dashboard's feature group eye ball logic
      this.featureGroupEnabled = true;  // dashboard's feature group checkbox logic
      this.selectedFeaturesHistory = []; // array of strings(names). updated every time item is selected
      this.filtersReceived = null; // array of filters values, comes from BE, for ex [1221, 347, 1124]
      this.confirmedChange = false; // same as firstClick, but fires after someone changes feature and confirms changes
      this.featureBeforeChange = null; // feature that sets when menu is opened (to revert it back if user didn't confirm change)
    }
    if (isParent) {
      this.partThumbnail = '';
      this.relatedItems = [];
    }
    if (!isChild && !isParent) {
      this.dbFeature = null;
      this.layer = new Layer("bv");
      this._customDisplayName = null;
      this.notesList = {};
    }
    this.partName = "";
  }

  set features(featuresList) {
    // features can't be set directly, we need to change featuresList array
  }
  get features() {
    const layout = this.layout || this.getParent().layout;
    return this.featuresList[layout.getCurrentLayoutName()]
  }
  set featuresParts(featuresList) {
    // featuresParts can't be set directly, we need to change featuresPartsList array
  }
  get featuresParts() {
    const layout = this.layout || this.getParent().layout;
    return this.featuresPartsList[layout.getCurrentLayoutName()]
  }

  /**
   * Checks whether a given for condition matches the needed value (or array of values)
   * @param name {string}
   * @param value {string || array}
   * @returns {boolean}
   */
  matchesMetaForCondition(name, value) {
    if (!this.metaData[name]) {
      return false
    }
    if (Array.isArray(this.metaData[name])) {
      return this.metaData[name].some(condValue => {
        return condValue === METADATA.ALL || (Array.isArray(value) ? value.some(val => iCmp(condValue, val)) : iCmp(condValue, value))
      });
    }
    return this.metaData[name] === METADATA.ALL
      || (Array.isArray(value) ? value.some(val => iCmp(this.metaData[name], val)) : iCmp(this.metaData[name], value))
  }

  matchesMetaForArrayOfConditions(arrayOfConditions) {
    return arrayOfConditions.every((condition) => {
      return this.matchesMetaForCondition(condition.propName, condition.propValue);
    })
  }

  navigationItem() {
    return new DesignNavigationItem(this.partName, this)
  }
}


